// @ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addHeaders } from 'common/services/rest-api.service';
import { env } from 'env';

export const loadList = createAsyncThunk('integrations/loadList', async (_, thunkAPI) => {
  const path = `${env.REACT_APP_BASE_URL}settings/integrations/`;
  const res = await fetch(path, {
    method: 'GET',
    mode: 'cors',
    headers: addHeaders('GET'),
    credentials: 'include'
  }).then(data => {
    if (!data.ok) {
      return thunkAPI.rejectWithValue({
        status: data.status
      });
    }
    return data.json();
  });
  return res;
});

const integrationsSlice = createSlice({
  name: 'integrations',
  initialState: {
    component: '',
    visible: false,
    loading: false,
    list: [],
    categoryPopup: '',
    integrationDeleted: false
  },
  reducers: {
    showIntegration(state, action) {
      state.component = action.payload;
      state.visible = true;
    },
    hideIntegration(state) {
      state.component = '';
      state.visible = false;
    },
    showCategoryPopup: (state, action) => {
      state.categoryPopup = action.payload;
    },
    resetIntegrationPopup: state => {
      state.categoryPopup = '';
      state.integrationDeleted = false;
    },
    setIntegrationDeleted: (state, action) => {
      state.integrationDeleted = action.payload;
    }
  },
  extraReducers: {
    [loadList.pending]: state => {
      state.loading = true;
    },
    [loadList.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.list = payload;
      state.integrationDeleted = false;
    },
    [loadList.rejected]: state => {
      state.loading = false;
    }
  }
});

const { actions, reducer } = integrationsSlice;
export const {
  showIntegration,
  hideIntegration,
  showCategoryPopup,
  resetIntegrationPopup,
  setIntegrationDeleted
} = actions;
export default reducer;
